import { Component, OnInit } from '@angular/core';
import { DialogService } from '@cyborg-monorepo/common/angular/cyborg-ui';
import { Profile } from '@cyborg-monorepo/hunter/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../../../auth/auth.service';
import { CalendlyService } from '../../services/calendly.service';
import { UserService } from '../../services/user.service';

@Component({ standalone: false, 
  selector: 'contact-cyborg',
  templateUrl: './contact-cyborg.component.html',
  styleUrls: ['./contact-cyborg.component.scss'],
})
export class ContactCyborgComponent implements OnInit {
  public trial$: Observable<boolean>;
  public user: Profile;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    public dialog: DialogService,
    public calendlyService: CalendlyService,
  ) {}

  public ngOnInit(): void {
    this.trial$ = this.authService.user$.pipe(
      map((profile) => {
        return profile.company.status === 'trial';
      }),
    );

    this.userService.getProfile().subscribe((user) => {
      this.user = user;
    });
  }

  public contactCyborg(): void {
    this.calendlyService.talkToCyborg();
  }
}
